export enum TransactionStatus {
    pending = 'Pending',
    awaitingPayment = 'Awaiting Payment',
    paid = 'Paid',
    queried = 'Disputed'
}